import { HiOutlineMail } from "react-icons/hi";
import { BsLinkedin } from "react-icons/bs";
import { FaGithub } from "react-icons/fa";
import "./Contact.css";

const external = { target: "_blank", rel: "noreferrer" };

const CONTACT_METHODS = [
  {
    id: "email",
    icon: HiOutlineMail,
    title: "Email",
    detail: "trai4.t@gmail.com",
    href: "mailto:trai4.t@gmail.com",
    label: "Send email",
    external: false,
  },
  {
    id: "linkedin",
    icon: BsLinkedin,
    title: "LinkedIn",
    detail: "trai-torti",
    href: "https://www.linkedin.com/in/trai-torti-7980341a2/",
    label: "Connect on LinkedIn",
    external: true,
  },
  {
    id: "github",
    icon: FaGithub,
    title: "GitHub",
    detail: "darthjeditt",
    href: "https://github.com/darthjeditt",
    label: "View repositories",
    external: true,
  },
];

export default function Contact() {
  return (
    <section id="contact">
      <h5>Get in touch</h5>
      <h2>Contact</h2>
      <p className="section__lead">
        Based on the Gold Coast. Email is best — I typically reply within a couple of
        business days.
      </p>

      <div className="container contact__container">
        <div className="contact__options">
          {CONTACT_METHODS.map(
            ({ id, icon: Icon, title, detail, href, label, external: isExternal }) => (
              <article key={id} className="contact__option">
                <Icon className="contact__option-icon" aria-hidden />
                <h4>{title}</h4>
                <p className="contact__detail">{detail}</p>
                <a
                  href={href}
                  className="contact__link"
                  {...(isExternal ? external : {})}
                >
                  {label}
                </a>
              </article>
            )
          )}
        </div>
      </div>
    </section>
  );
}
